import React, { useState } from 'react';
import { useStyles } from './ModalStyles';
import Modal from '@material-ui/core/Modal';
import { useSelector } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

import AmeraSelect from '../../../../components/AmeraSelect';
import MenuItem from '@material-ui/core/MenuItem';

const AddTaskModal = ({
  open,
  handleClose,
  project_id,
  parent_id,
  heading,
  handleSubmit,
}) => {
  const classes = useStyles();

  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [assign_to, setAssign_to] = useState('');
  const [est_hours, setEst_hours] = useState('');

  const projects = useSelector((state) => {
    return state?.project?.projects.filter((o) => o.project_id === +project_id);
  });
  const members = projects[0]?.project_members;

  // eslint-disable-next-line
  const privilegeMember = members.map((member) => {
    if (
      member.privileges.includes('create') ||
      member.privileges.includes('edit')
    ) {
      return member;
    }
  });

  const ableMember = privilegeMember.filter(function (element) {
    return element !== undefined;
  });

  const getContractId = (project_mem_id) => {
    const contractObj = projects[0].contracts.filter((c) => {
      return c.rate_type === 'hourly' && c.project_member_id === project_mem_id;
    });
    return contractObj[0].contract_id;
  };
  //console.log('Contract ob', projects[0].contracts.filter((c) => (c.project_member_id === 8))[0].contract_id)
  const form = {
    project_id: Number(project_id),
    parent_id: heading === 'Epic' ? null : parent_id,
    element_type: heading.toLowerCase(),
    title: title,
    description: description,
    est_hours: Number(est_hours),
    contract_id:
      Number(assign_to) === 0 ? null : getContractId(Number(assign_to)),
    rate_type: 'hourly',
  };

  const submitHandler = () => {
    handleSubmit(form);
    setTitle('');
    setDescription('');
    setAssign_to('');
    setEst_hours('');
  };

  return (
    <Modal open={open}>
      <div className={classes.modal}>
        <div className={classes.modalTop}>
          <div>
            <h6 className={classes.modalTopText}>Add a Task</h6>
          </div>
          <div onClick={handleClose}>
            <IconButton className={classes.modalTopButton} aria-label="close">
              <CloseIcon />
            </IconButton>
          </div>
        </div>
        <hr />
        <Grid item xs={12}>
          <FormControl variant="outlined" className={classes.field}>
            <TextField
              label="Title"
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              InputLabelProps={{
                shrink: true,
              }}
              variant="outlined"
            />
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <FormControl variant="outlined" className={classes.field}>
            <TextareaAutosize
              className={classes.inputDescription}
              type="text"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              rowsMin={5}
              placeholder="Description"
            />
          </FormControl>
        </Grid>

        <Grid container spacing={3}>
          <Grid item xs={6}>
            <FormControl variant="outlined" className={classes.field}>
              <AmeraSelect
                id={parent_id}
                label="Assign to"
                value={assign_to}
                onChange={(e) => setAssign_to(e.target.value)}
              >
                {ableMember &&
                  ableMember.map((member) => (
                    <MenuItem
                      key={member.project_member_id}
                      id={member.project_member_id}
                      value={member.project_member_id}
                    >
                      {member.first_name} {member.last_name}
                    </MenuItem>
                  ))}
              </AmeraSelect>
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl variant="outlined" className={classes.field}>
              <TextField
                label="Estimated Hours"
                type="number"
                value={est_hours}
                onChange={(e) => setEst_hours(e.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
                variant="outlined"
              />
            </FormControl>
          </Grid>
        </Grid>

        <Button
          onClick={submitHandler}
          className={classes.button}
          disabled={!title && true}
          variant="contained"
          color="primary"
        >
          <span className={classes.buttonText}>Create Task</span>
        </Button>
      </div>
    </Modal>
  );
};

export default AddTaskModal;
